export const BUSINESS = {
    name: "WBS Serviços Contábeis",
    cnpj: "61.775.971/0001-06",
    crc: "CRC 2SP051732/O-6",
    phoneDisplay: "(11) 93962-3265",
    phoneRaw: "+5511939623265",
    whatsapp: "https://wa.me/5511939623265",
    email: "welton@wbscontabil.com.br",
    address: "Rua Cel. Jose Eusebio nº 95 - Casa 13, Higienópolis, São Paulo - SP",
};

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMG1lZXRpbmclMjBvZmZpY2V8ZW58MHx8fHwxNzkxMzc1MzQzfDA&ixlib=rb-4.1.0&q=85",
    services: "https://images.unsplash.com/photo-1648201637025-1c77b9be3013?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxjYWxjdWxhdG9yJTIwZmluYW5jaWFsJTIwY2hhcnRzfGVufDB8fHx8MTc5MTM3NTM0M3ww&ixlib=rb-4.1.0&q=85",
    location: "https://images.unsplash.com/photo-1561592390-42c07289e9cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxzYW8lMjBwYXVsbyUyMGNpdHlzY2FwZXxlbnwwfHx8fDE3OTEzNzUzNDN8MA&ixlib=rb-4.1.0&q=85",
    accountant: "https://images.unsplash.com/photo-1648201637025-1c77b9be3013?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxjYWxjdWxhdG9yJTIwZmluYW5jaWFsJTIwY2hhcnRzfGVufDB8fHx8MTc5MTM3NTM0M3ww&ixlib=rb-4.1.0&q=85",
};
